"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocateSelectedPickupPointOnReopen = void 0;
var _react = require("react");
var _contexts = require("../../../contexts");
var _hooks = require("../../../hooks");
/**
 * Locates selected pickup point on map on reopen.
 */
const useLocateSelectedPickupPointOnReopen = open => {
  const [previouslyClosed, setPreviouslyClosed] = (0, _react.useState)(false);
  const {
    pickupPointsMapProps: {
      selectedMapPickupPoint
    }
  } = (0, _contexts.useMap)();
  const {
    mapMethods
  } = (0, _hooks.usePickupPointsSearchConfiguration)();
  (0, _react.useEffect)(() => {
    if (open && previouslyClosed) {
      const {
        latitude,
        longitude
      } = selectedMapPickupPoint?.coordinates ?? {};
      if (latitude != null && longitude != null) {
        setTimeout(() => mapMethods.current?.setLocationOrZoom({
          location: {
            latitude,
            longitude
          }
        }));
      }
    }
    setPreviouslyClosed(!open);
  }, [mapMethods, open, previouslyClosed, selectedMapPickupPoint]);
};
exports.useLocateSelectedPickupPointOnReopen = useLocateSelectedPickupPointOnReopen;